module.exports = __webpack_public_path__ + "img/register_white.ded5c856.svg";